import { useIntl } from 'react-intl';

import { SearchInput } from '~/eds/src/components/SearchInput/SearchInput';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { Table } from '~/eds/src/modules/Table/Table';

const Page = () => {
  const intl = useIntl();
  const mockData = [
    { id: 1, party: 'Internal', documentCount: 67 },
    { id: 2, party: 'External', documentCount: 89 },
  ];

  // TODO: remove client_id param, filter by "parties" entity type
  // or better, getEntityInstancesByEntityType
  // const { data, isLoading } = api.endpoints.getEntityInstanceByClient.useQuery({
  // clientId: 173471,
  // });

  const columns = [
    {
      key: 'party',
      cellType: 'link',
      title: intl.formatMessage({
        id: 'ManagedEntityPartiesPage.partyColumnTitle',
        defaultMessage: 'Party',
        description: 'Column title for party name in parties table',
      }),
      // TODO: update data type
      mapCellProps: (data: any) => ({
        text: data.party,
        pathname: `/parties/${data.party}`,
      }),
    },
    {
      key: 'document-count',
      cellType: 'number',
      title: intl.formatMessage({
        id: 'ManagedEntityPartiesPage.documentsColumnTitle',
        defaultMessage: 'Documents',
        description: 'Column title for document count in parties table',
      }),
      // TODO: update data type
      mapCellProps: (data: any) => ({
        number: data.documentCount,
      }),
    },
  ];

  return (
    <PageLayout
      title={intl.formatMessage({
        id: 'ManagedEntityPartiesPage.pageTitle',
        defaultMessage: 'Parties',
        description: 'Page title for managed entity parties page',
      })}
      actions={[
        {
          text: intl.formatMessage({
            id: 'ManagedEntityPartiesPage.newPartyButton',
            defaultMessage: 'New Party',
            description: 'Button text for creating a new party',
          }),
          level: 'primary',
          onClick: () => console.log('click'),
        },
      ]}
    >
      {/* TODO: wrap in Layout and set width */}
      <SearchInput
        name="party"
        value="call api to filter table"
        onChange={() => console.log('type')}
      />
      <Table name="parties" columns={columns} data={mockData} />
    </PageLayout>
  );
};

export default Page;
